import React from 'react';
const testimonials = [{
  initials: 'MF',
  name: 'María F.',
  location: 'Buenos Aires · Lashista',
  quote: 'En la primera semana apliqué el sistema de seña y se me cortaron las cancelaciones de raíz. Antes perdía 3 o 4 turnos por semana. Ahora en un mes tuve UNO solo y lo cubrí en 15 minutos con el bono de rescate.'
}, {
  initials: 'VL',
  name: 'Valentina L.',
  location: 'Córdoba · Lashista',
  quote: 'Los mensajes del Bono 2 me cambiaron la vida. Antes me quedaba en blanco cuando una clienta cancelaba tarde. Ahora copio, pego y listo. Sin culpa, sin drama, sin perder plata.'
}, {
  initials: 'SR',
  name: 'Sofía R.',
  location: 'Rosario · Lashista',
  quote: 'El Checklist de Clienta de Riesgo me salvó de dos cancelaciones en la misma semana. Vi las señales, apliqué el protocolo rojo y evité dos huecos que antes me hubieran arruinado el jueves.'
}];
const painPoints = ['Abrís WhatsApp y hay un mensaje que dice "che no puedo ir hoy" a las 9 de la mañana cuando el turno es a las 10', 'Pusiste políticas pero cuando llegó el momento de aplicarlas no supiste qué decir y cediste igual por no generar conflicto', 'Tenés huecos en la agenda todas las semanas y no tenés idea de cómo cubrirlos rápido sin desesperarte ni bajar el precio', 'Hay clientas que "siempre tienen algo" y vos seguís atendiéndolas porque no sabés cómo filtrarlas desde el principio', 'Sabés que tenés que cobrar seña pero cuando llega el momento te da vergüenza pedirla y terminás sin cobrarla', 'Al final del mes trabajaste mucho pero los números no cierran porque los turnos caídos se comieron la ganancia', 'Tu espalda, tu cuello y tus ojos están pagando el precio de una agenda mal organizada y un cuerpo sin protocolo de protección'];
export function ProblemSection() {
  return <section className="py-12 md:py-24 bg-[#F4EDE4]" data-id="element-146">
      <div className="max-w-6xl mx-auto px-4" data-id="element-147">
        {/* Section eyebrow */}
        <div className="text-center mb-8 md:mb-14" data-id="element-148">
          <div className="text-[10px] tracking-[0.3em] text-[#B8956A] font-bold uppercase mb-3" data-id="element-149">
            ⭐ Lo que dicen las que ya lo tienen
          </div>
        </div>

        {/* Testimonials */}
        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-3 sm:gap-5 md:gap-6 mb-12 md:mb-28" data-id="element-150">
          {testimonials.map((t, i) => <div key={i} className="bg-white border border-[#E8D5C4] rounded-2xl p-4 sm:p-6 hover:border-[#B8956A] hover:-translate-y-0.5 transition-all shadow-sm" data-id="element-151">
              <div className="flex items-center gap-3 mb-3 sm:mb-4" data-id="element-152">
                <div className="w-10 h-10 sm:w-11 sm:h-11 rounded-full bg-[#FAF6F0] text-[#5A2A3D] flex items-center justify-center font-bold text-sm border border-[#E8D5C4]" data-id="element-153">
                  {t.initials}
                </div>
                <div data-id="element-154">
                  <div className="text-[#B8956A] text-xs tracking-wider mb-0.5" data-id="element-155">
                    ★★★★★
                  </div>
                  <div className="text-sm text-[#2D1A22] font-medium" data-id="element-156">
                    {t.name}
                  </div>
                </div>
              </div>
              <p className="text-[#5A4A4F] italic leading-relaxed text-xs sm:text-sm md:text-base" data-id="element-157">
                "{t.quote}"
              </p>
              <div className="mt-3 sm:mt-4 text-[10px] sm:text-xs text-[#B8956A] font-medium tracking-wider uppercase" data-id="element-158">
                {t.location}
              </div>
            </div>)}
        </div>

        {/* Pain Points */}
        <div className="max-w-3xl mx-auto text-center mb-7 sm:mb-12" data-id="element-159">
          <h2 className="text-2xl sm:text-3xl md:text-5xl text-[#2D1A22] mb-4 sm:mb-6 leading-tight" data-id="element-160">
            ¿Cuántos lunes más vas a seguir mirando{' '}
            <span className="italic" data-id="element-161">el hueco en tu agenda</span>?
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-[#5A4A4F] leading-relaxed" data-id="element-162">
            Querés tener el negocio que te merecés. Tenés la técnica. Pero nadie
            te dijo que ibas a pasar los domingos con el estómago apretado
            esperando si la clienta del lunes confirma o no, los martes con un
            turno vacío que podrías haber llenado y los viernes contando cuánta
            plata perdiste esa semana por culpa de alguien que no apareció.
          </p>
          <p className="text-base sm:text-lg md:text-xl text-[#5A2A3D] italic font-medium mt-4 sm:mt-6" data-id="element-163">
            No es falta de clientas. Es falta de un sistema.
          </p>
        </div>

        <div className="max-w-3xl mx-auto bg-white border border-[#E8D5C4] rounded-2xl md:rounded-3xl p-5 sm:p-6 md:p-10 shadow-md" data-id="element-164">
          <div className="space-y-3.5 sm:space-y-5" data-id="element-165">
            {painPoints.map((point, i) => <div key={i} className="flex items-start gap-2.5 sm:gap-4" data-id="element-166">
                <span className="text-[#5A2A3D] text-base sm:text-lg mt-0.5 shrink-0" data-id="element-167">
                  ❌
                </span>
                <p className="text-xs sm:text-sm md:text-base text-[#5A4A4F] leading-relaxed" data-id="element-168">
                  {point}
                </p>
              </div>)}
          </div>
        </div>

        <div className="text-center mt-8 sm:mt-16" data-id="element-169">
          <h3 className="text-xl sm:text-2xl md:text-4xl text-[#2D1A22]" data-id="element-170">
            ¿Y si este fuera el último lunes que{' '}
            <span className="italic text-[#5A2A3D]" data-id="element-171">
              perdés un turno sin sistema
            </span>
            ?
          </h3>
        </div>
      </div>
    </section>;
}